// Central URL/asset sanitizers. An allowlist (not a denylist) so obfuscated
// javascript:/vbscript:/data: script vectors can never slip through.
export function isSafeHref(href: string | null | undefined): boolean {
  if (!href) return false;
  const t = href.trim().toLowerCase();
  return (
    t.startsWith('https://') || t.startsWith('http://') ||
    t.startsWith('/') || t.startsWith('#') || t.startsWith('mailto:')
  );
}
export function safeHref(href: string | null | undefined): string {
  return isSafeHref(href) ? (href as string) : '#';
}
/** Image sources: only http(s), root-relative, or data:image/*. Blocks
 * javascript:/data:text/html and other script-capable schemes. Returns null if unsafe. */
export function safeImageSrc(src: string | null | undefined): string | null {
  if (!src) return null;
  const t = src.trim().toLowerCase();
  if (t.startsWith('https://') || t.startsWith('http://') || t.startsWith('/') || t.startsWith('data:image/')) {
    return src as string;
  }
  return null;
}
